// Lê a duração do vídeo direto do player e preenche o campo do cadastro.
//
// A duração é o DENOMINADOR do progresso do aluno (ver Learning::WatchedPercent):
// aula sem ela fica fora da conta, e o sintoma não aparece em tela nenhuma — a
// aula esquecida simplesmente deixa de ser medida. Depender de alguém digitar o
// número a cada cadastro tinha esse custo silencioso.
//
// == Por que no navegador, e não no servidor ==
//
// O servidor já busca a duração (Learning::SourceDuration), mas o YouTube só a
// entrega pela Data API, que exige chave — e nem toda empresa cadastrou a dela.
// Aqui não precisa: o próprio player informa a duração pelo mesmo canal de
// mensagens que a tela da aula usa para acompanhar a reprodução. É a mesma
// regra, aplicada uma etapa antes.
//
// O número só entra se o campo estiver VAZIO. O que uma pessoa digitou vale
// mais: há quem corte a vinheta do fim da contagem de propósito.
//
// ⚠️ As expressões de provedor abaixo repetem as de LearningHelper#learning_embed_url
// e Learning::SourceDuration. Elas moram nos três lugares porque um é view, o
// outro é serviço e este roda no navegador, antes de existir requisição — se um
// provedor novo entrar, entra nos três.
const PROBE_TIMEOUT = 8000
const YOUTUBE_ID = /(?:youtu\.be\/|youtube\.com\/(?:watch\?(?:.*&)?v=|embed\/))([\w-]{6,})/
const VIMEO_ID = /vimeo\.com\/(?:video\/)?(\d+)/
const BARE_ID = /^[\w-]{6,}$/
// Mídia servida direto (o mp3 no servidor da empresa, o mp4 num bucket): não há
// player de provedor para perguntar, mas o próprio navegador lê a duração ao
// carregar os metadados. Mesmos formatos que a tela da aula toca.
const DIRECT_MEDIA = /\.(mp3|m4a|aac|ogg|wav|mp4|webm|mov)(\?|#|$)/i

function initContentDuration() {
    const source = document.querySelector("[data-duration-source]")
    const duration = document.querySelector("[data-duration-field]")
    const hint = document.querySelector("[data-duration-hint]")
    if (!source || !duration) return

    let probing = null

    source.addEventListener("change", () => probe())
    source.addEventListener("blur", () => probe())

    function probe() {
        // Campo preenchido é decisão de gente: não se mexe.
        if (duration.value.trim() !== "") return

        const raw = source.value.trim()
        const alvo = target(raw)
        if (!alvo || alvo.url === probing) return

        probing = alvo.url
        say("Lendo a duração do vídeo…")
        const leitura = alvo.direct ? readMediaDuration(alvo.url) : readDuration(alvo.url)
        leitura
            .then((seconds) => {
                if (!seconds || duration.value.trim() !== "") return say("")
                duration.value = Math.max(Math.round(seconds / 60), 1)
                duration.dispatchEvent(new Event("input", { bubbles: true }))
                say(`Duração lida do vídeo: ${clock(seconds)}. Ajuste se quiser.`)
            })
            .catch(() => say("Não consegui ler a duração daqui — preencha à mão."))
    }

    function say(message) {
        if (hint) hint.textContent = message
    }

    // Monta um player escondido e escuta a duração que ele anuncia. O iframe é
    // descartado ao fim, com ou sem resposta: ele existe só para essa pergunta.
    function readDuration(embed) {
        return new Promise((resolve, reject) => {
            const frame = document.createElement("iframe")
            frame.src = embed
            frame.width = 0
            frame.height = 0
            frame.style.cssText = "position:absolute;width:0;height:0;border:0;visibility:hidden"
            frame.allow = "encrypted-media"

            const vimeo = embed.includes("vimeo.com")
            let hello = null

            const finish = (seconds, error) => {
                clearInterval(hello)
                clearTimeout(timer)
                window.removeEventListener("message", onMessage)
                frame.remove()
                error ? reject(error) : resolve(seconds)
            }

            const timer = setTimeout(() => finish(null, new Error("sem resposta")), PROBE_TIMEOUT)

            function onMessage(event) {
                if (event.source !== frame.contentWindow) return

                const data = parse(event.data)
                if (!data) return

                // YouTube anuncia a duração junto do resto do estado; o Vimeo
                // responde quando perguntado, e só depois de ficar pronto.
                const seconds = vimeo
                    ? (data.event === "ready"
                        ? (post(frame, { method: "getDuration" }), null)
                        : (data.method === "getDuration" ? Number(data.value) : null))
                    : Number(data?.info?.duration)

                if (seconds > 0) finish(seconds)
            }

            window.addEventListener("message", onMessage)
            document.body.appendChild(frame)

            if (!vimeo) {
                // O player do YouTube só passa a emitir depois que alguém se
                // apresenta, e não há evento de "pronto para conversar".
                hello = setInterval(
                    () => post(frame, { event: "listening", id: 1, channel: "widget" }),
                    400,
                )
            }
        })
    }

    function post(frame, message) {
        frame.contentWindow?.postMessage(JSON.stringify(message), "*")
    }

    function parse(data) {
        if (typeof data !== "string") return data
        try {
            return JSON.parse(data)
        } catch {
            return null
        }
    }

    // Onde perguntar a duração — e por qual caminho.
    function target(raw) {
        const url = mediaUrl(raw)
        if (url) return { url, direct: true }

        const embed = embedUrl(raw)
        return embed ? { url: embed, direct: false } : null
    }

    // Arquivo servido direto: o navegador carrega só os metadados e diz a
    // duração. Nada é reproduzido, e o elemento é descartado em seguida.
    function readMediaDuration(url) {
        return new Promise((resolve, reject) => {
            const media = document.createElement("video")
            media.preload = "metadata"
            media.muted = true
            media.src = url

            const timer = setTimeout(() => finish(null, new Error("sem resposta")), PROBE_TIMEOUT)
            function finish(seconds, error) {
                clearTimeout(timer)
                media.removeAttribute("src")
                media.load()
                error ? reject(error) : resolve(seconds)
            }

            media.addEventListener("loadedmetadata", () => finish(media.duration))
            media.addEventListener("error", () => finish(null, new Error("não carregou")))
        })
    }

    function mediaUrl(raw) {
        const url = raw.match(/https?:\/\/\S+/)?.[0]
        return url && DIRECT_MEDIA.test(url) ? url : null
    }

    // Aceita o que o cadastro aceita: embed colado, URL ou só o ID (que, por
    // convenção, é do YouTube).
    function embedUrl(raw) {
        const youtube = raw.match(YOUTUBE_ID)
        if (youtube) return `https://www.youtube.com/embed/${youtube[1]}?enablejsapi=1`

        const vimeo = raw.match(VIMEO_ID)
        if (vimeo) return `https://player.vimeo.com/video/${vimeo[1]}`

        if (BARE_ID.test(raw)) return `https://www.youtube.com/embed/${raw}?enablejsapi=1`

        return null
    }

    function clock(seconds) {
        const total = Math.floor(seconds)
        const s = String(total % 60).padStart(2, "0")
        return `${Math.floor(total / 60)}:${s}`
    }
}

document.addEventListener("DOMContentLoaded", initContentDuration)
